import { useEffect, useMemo, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { useAppDispatch, useAppSelector } from 'app/hooks'
import { TableLoader } from 'components/Table'

import { StyledConfigHeader } from '../styles'
import { HomeActiveConfigTable } from '../..'

import { useHomeRouteParams } from 'features/home/hooks'
import { homeActiveConfigSelector } from 'features/home/selectors'
import { WhiteBlock } from 'components/Layout'
import { homeActiveConfigurationMessages } from '../messages'
import { homeActiveConfigActions } from '../slice'

function HomeActiveConfig() {
  const { homeId } = useHomeRouteParams()
  const dispatch = useAppDispatch()

  const [initialLoaded, setInitialLoaded] = useState(false)

  const isHomeActiveConfigFetching = useAppSelector(
    homeActiveConfigSelector.isFetching
  )
  const isHomeActiveConfigLoaded = useAppSelector(
    homeActiveConfigSelector.isFinished
  )
  const hasHomeActiveConfigError = useAppSelector(
    homeActiveConfigSelector.error
  )
  const homeActiveConfig = useAppSelector(homeActiveConfigSelector.data)

  useEffect(() => {
    return () => {
      dispatch(homeActiveConfigActions.clear())
    }
  }, [dispatch, homeId])

  useEffect(() => {
    if (!isHomeActiveConfigFetching && isHomeActiveConfigLoaded) {
      setInitialLoaded(true)
    }
  }, [isHomeActiveConfigLoaded, isHomeActiveConfigFetching])

  const memoizedHomeActiveConfigList = useMemo(
    () => (homeActiveConfig ? [homeActiveConfig] : []),
    [homeActiveConfig]
  )

  return (
    <>
      <StyledConfigHeader>
        <h2>
          <FormattedMessage {...homeActiveConfigurationMessages.activeHeader} />
        </h2>
      </StyledConfigHeader>

      {!initialLoaded && <TableLoader />}

      {hasHomeActiveConfigError && (
        <WhiteBlock bigPadding>Something went wrong</WhiteBlock>
      )}

      {isHomeActiveConfigLoaded &&
        !homeActiveConfig?.active &&
        !hasHomeActiveConfigError && (
          <WhiteBlock bigPadding>
            <FormattedMessage {...homeActiveConfigurationMessages.noConfig} />
          </WhiteBlock>
        )}

      {isHomeActiveConfigLoaded &&
        homeActiveConfig?.active &&
        !hasHomeActiveConfigError && (
          <HomeActiveConfigTable data={memoizedHomeActiveConfigList} />
        )}

      {homeActiveConfig && !homeActiveConfig?.active && (
        <>
          <StyledConfigHeader>
            <h2>
              <FormattedMessage
                {...homeActiveConfigurationMessages.lastActiveHeader}
              />
            </h2>
          </StyledConfigHeader>
          {!initialLoaded && <TableLoader />}
          {hasHomeActiveConfigError && (
            <WhiteBlock bigPadding>Something went wrong</WhiteBlock>
          )}
          {isHomeActiveConfigLoaded &&
            !homeActiveConfig?.active &&
            !hasHomeActiveConfigError && (
              <HomeActiveConfigTable data={memoizedHomeActiveConfigList} />
            )}
        </>
      )}
    </>
  )
}

export default HomeActiveConfig
